"use strict";
/** Схемы этапов проекта и требований готовности. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkRequirementItemSchema = exports.reorderRequirementsSchema = exports.updateRequirementSchema = exports.createRequirementSchema = exports.reorderStagesSchema = exports.updateStageSchema = exports.createStageSchema = void 0;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
// --- Этапы ---------------------------------------------------------------
const stageNameSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'Укажите название этапа')
    .max(200, 'Название не длиннее 200 символов');
exports.createStageSchema = zod_1.z.object({
    name: stageNameSchema,
    descriptionMd: common_1.markdownSchema.nullish(),
    targetDate: common_1.isoDateSchema.nullish(),
    /**
     * Сделать этап текущим сразу при создании. Текущий этап на проект один:
     * прежний будет снят той же транзакцией.
     */
    makeCurrent: zod_1.z.boolean().default(false),
});
exports.updateStageSchema = zod_1.z.object({
    name: stageNameSchema.optional(),
    descriptionMd: common_1.markdownSchema.nullish(),
    /**
     * Прямое назначение статуса CURRENT запрещено: переход выполняется
     * отдельной операцией, которая снимает признак с прежнего этапа
     * в одной транзакции.
     */
    status: zod_1.z
        .enum(contracts_1.STAGE_STATUSES.filter((status) => status !== 'CURRENT'))
        .optional(),
    targetDate: common_1.isoDateSchema.nullish(),
});
exports.reorderStagesSchema = zod_1.z.object({
    order: zod_1.z.array(common_1.uuidSchema).min(1, 'Список этапов пуст').max(100),
});
// --- Требования ----------------------------------------------------------
const requirementTitleSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'Укажите формулировку требования')
    .max(300, 'Формулировка не длиннее 300 символов');
exports.createRequirementSchema = zod_1.z.object({
    title: requirementTitleSchema,
    descriptionMd: common_1.markdownSchema.nullish(),
    status: zod_1.z.enum(contracts_1.REQUIREMENT_STATUSES).default('TODO'),
    ownerId: common_1.uuidSchema.nullish(),
});
exports.updateRequirementSchema = zod_1.z.object({
    title: requirementTitleSchema.optional(),
    descriptionMd: common_1.markdownSchema.nullish(),
    status: zod_1.z.enum(contracts_1.REQUIREMENT_STATUSES).optional(),
    ownerId: common_1.uuidSchema.nullish(),
});
exports.reorderRequirementsSchema = zod_1.z.object({
    order: zod_1.z.array(common_1.uuidSchema).min(1, 'Список требований пуст').max(200),
});
/** Привязка результата к требованию: одно требование закрывается несколькими. */
exports.linkRequirementItemSchema = zod_1.z.object({
    itemId: common_1.uuidSchema,
});
//# sourceMappingURL=stages.js.map